import React from 'react';
import PropTypes from 'prop-types';

import UserAvatar from 'dpl/path_to_payment/components/UserAvatar';
import {
  DROP_OFF_FEE_TYPE_OPTIONS,
  DROP_OFF_FEE_TYPES
} from 'dpl/breeder_account/utils/constants';
import Badge from 'dpl/common/design_system/Badge';
import { useBreederProfileData } from 'dpl/components/BreederProfile/mobile/hooks/useBreederProfileData';
import LoadingSpinner from 'dpl/components/LoadingSpinner';

import { TRANSPORT_DETAILS_TYPES } from './utils/constants';

const { HOME, AIRPORT, MEETUP } = TRANSPORT_DETAILS_TYPES;

function getDropOffFeeTypeTitle(dropOffFeeType) {
  if (dropOffFeeType && dropOffFeeType !== DROP_OFF_FEE_TYPES.OTHER) {
    return DROP_OFF_FEE_TYPE_OPTIONS.find(
      option => option.value === dropOffFeeType
    ).title;
  }
  return null;
}
/** @param {any} props */
export default function TransportDetailsDescription({
  customDescription = '',
  defaultDescription,
  transportType,
  hasFreeDropOff = false,
  dropOffFeeType = null,
  dropOffFeeTypeDescription = null
}) {
  const { breeder, isFetchingBreeder } = useBreederProfileData();

  if (isFetchingBreeder) {
    return <LoadingSpinner />;
  }

  const {
    user: { id: userId, full_name: fullName },
    initials,
    profile_photo_url: profilePhotoUrl
  } = breeder;

  const dropOffFeeTypeTitle = dropOffFeeType
    ? getDropOffFeeTypeTitle(dropOffFeeType)
    : null;

  return (
    <div className="TransportDetailsDescription bg-sand br12 ph4 pv4 ph6-md pv6-md">
      <div className="flex flex-column gap-8 md:gap-16">
        {transportType === MEETUP && hasFreeDropOff && (
          <Badge
            variant="bright"
            color="strollBright"
            size="xsmall"
            className="max-content"
          >
            Free
          </Badge>
        )}
        {transportType === MEETUP &&
          !hasFreeDropOff &&
          Boolean(dropOffFeeTypeTitle || dropOffFeeTypeDescription) && (
            <div className="flex flex-wrap items-center secondary font-16 gap-8">
              {dropOffFeeTypeTitle && (
                <p className="fw-medium">{dropOffFeeTypeTitle}</p>
              )}
              {dropOffFeeTypeDescription && <p>{dropOffFeeTypeDescription}</p>}
            </div>
          )}
        <p className="font-16 secondary">
          {customDescription || defaultDescription}
        </p>
        {/* Only want to show if the breeder-added description is available, not just the default description */}
        {customDescription && (
          <div className="flex items-center gap-8">
            <UserAvatar
              user={{
                id: userId,
                initials,
                profile_photo_url: profilePhotoUrl
              }}
              size="sm"
            />
            {fullName && <p className="font-16 secondary">{fullName}</p>}
          </div>
        )}
      </div>
    </div>
  );
}

TransportDetailsDescription.propTypes = {
  customDescription: PropTypes.string,
  defaultDescription: PropTypes.string.isRequired,
  transportType: PropTypes.oneOf([HOME, AIRPORT, MEETUP]).isRequired,
  hasFreeDropOff: PropTypes.bool,
  dropOffFeeType: PropTypes.string,
  dropOffFeeTypeDescription: PropTypes.string
};
